import { AVAILABLE_BONUSES } from 'common/constants/bonus.constants';
import { AccountUtils } from 'common/utils/account.util';
import { BonusUtils, INITIAL_BONUS_IDS_LIST } from 'common/utils/bonus.util';
import { action, computed, observable, makeObservable } from 'mobx';
import { isEqualObjects } from 'common/utils/common.utils';
import { IS_DISONA } from '../utils/style.util';

class BonusStore {
  @observable bonusesList = [];

  @observable allBonusesDetails = [];

  @observable bonusDetails = {};

  @observable bonusState = {};

  @observable selectedBonusID = IS_DISONA
    ? '386f21da-b985-494c-91fb-6de751ca7cdd'
    : '0f64284c-fa10-4813-ac2c-45303b16a536';

  @observable selectedAccount = null;

  @observable isLoading = true;

  @observable promoCode = '';

  @observable promoCodeError = false;

  @observable bonusIDs = INITIAL_BONUS_IDS_LIST;

  constructor() {
    makeObservable(this);
  }

  @computed get selectedAccountID() {
    return this.selectedAccount?.accountID;
  }

  @computed get selectedAccountBalance() {
    return this.selectedAccount?.accountInfo.balance;
  }

  @computed get selectedAccountOption() {
    return {
      value: this.selectedAccount && this.selectedAccountID,
      label:
        this.selectedAccount &&
        AccountUtils.makeAccountFullName(this.selectedAccount),
    };
  }

  @computed get getBonusIDs() {
    return this.bonusIDs;
  }

  @computed get detailedBonusesList() {
    return Object.fromEntries(
      this.bonusesList
        .map((item) => [
          item,
          {
            ...BonusUtils.getBonusDescription(item),
            ...this.bonusState,
            ...this.bonusDetails,
          },
        ])
        .filter(([, bonus]) => !bonus?.tab)
    );
  }

  @computed get selectedBonus() {
    return this.detailedBonusesList[this.selectedBonusID];
  }

  @action addBonusDetails = (details) => {
    if (!this.allBonusesDetails.find((item) => isEqualObjects(item, details))) {
      this.allBonusesDetails = [...this.allBonusesDetails, details];
    }
  };

  @action setBonusState = (state) => {
    this.bonusState = state;
  };

  @action setIsLoading = (val) => {
    this.isLoading = val;
  };

  @action setPromoCode = (code) => {
    this.promoCode = code;
  };

  @action setpromoCodeError = (state) => {
    this.promoCodeError = state;
  };

  @action setSelectedBonusID = (id) => {
    this.selectedBonusID = id;
  };

  @action setBonusIDs = (ids) => {
    const filtredBonuses = ids.filter((bonus) =>
      AVAILABLE_BONUSES.includes(bonus)
    );
    this.bonusIDs = BonusUtils.sortByGuids(filtredBonuses);
  };

  @action setSelectedAccount = (account) => {
    this.selectedAccount = account;
  };

  @action setBonusesList = (bonuses) => {
    this.bonusesList = bonuses;
  };

  @action setBonusDetails = (details) => {
    this.bonusDetails = details;
  };
}

const bonusStore = new BonusStore();

export default bonusStore;
